import { getDonations } from './getDonations'
import { getTotalsDonations } from './getTotalDonations'
import { getDonationDetail } from './getDonationDetail'

export {
  getDonations,
  getTotalsDonations,
  getDonationDetail
}
